import { Observable } from 'rxjs';

import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { ISnListQueryParameters, ISnListResponse } from '@lib/api';
import { SnEvidenceCase } from '@lib/api/entities';
import { SnIntegrationsAPI } from '@lib/api/services';
import { SnDataListComponent } from '@lib/ui/data-list';

@Component({
  selector: 'sn-incident-case-search-dialog',
  templateUrl: './incident-case-search-dialog.component.html',
  styleUrls: ['./incident-case-search-dialog.component.scss'],
})
export class IncidentCaseSearchDialogComponent implements OnInit {
  @ViewChild('listElement', { static: false })
  public readonly list: SnDataListComponent<SnEvidenceCase>;
  public readonly loadData = this._loadData.bind(this);

  public readonly columns: string[] = this._genColumns();

  public queryParams: any = {};

  constructor(
    private readonly _evidenceAPI: SnIntegrationsAPI,
    private readonly _matDialogRef: MatDialogRef<IncidentCaseSearchDialogComponent>,
  ) {}

  public ngOnInit(): void {}

  public onSearchValueChange(filterValue: string): void {
    this.queryParams.search = filterValue;
    this._reloadData();
  }

  public select(evidence: SnEvidenceCase): void {
    this._submit(evidence);
  }

  private _submit(evidence: SnEvidenceCase): void {
    this._matDialogRef.close(evidence);
  }

  private _loadData(params: ISnListQueryParameters): Observable<ISnListResponse<SnEvidenceCase>> {
    return this._evidenceAPI.getEvidenceCaseListv2(this._prepareLoadQueryParameters(params));
  }

  private _prepareLoadQueryParameters<T>(params: T): T {
    return {
      search: this.queryParams.search,
      ...params,
    };
  }

  private _reloadData(): void {
    this.list?.reference?.reload();
  }

  private _genColumns(): string[] {
    return ['name'];
  }
}
